import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import Content from './Content';
import Loading from './Loading';

import { useContext } from '../../Context';

export default function Index() {
  const navigate = useNavigate();

  const { id } = useParams();

  const { actions, state } = useContext();

  const [session, setSession] = useState(null);

  const onHide = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (state.token) {
      actions.show(state.token, id, (data) => {
        setSession(data);
      })
    }
  }, [state.token])

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Session Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {session ? <Content session={session} /> : <Loading />}
      </Modal.Body>
    </Modal>
  );
}
